export default "__VITE_ASSET__B2j$J0uU__"